// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Env = require("./reason/common/Env.bs.js");
let React = require("react");
let ButtonsV5 = require("./v5/common/Components/ButtonsV5.bs.js");
let GraphqlWs = require("graphql-ws");
let AuthSession = require("./utils/AuthSession.bs.js");
let ReactUpdate = require("rescript-react-update/src/ReactUpdate.bs.js");
let Stdlib_List = require("@rescript/runtime/lib/js/Stdlib_List.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let SystemMessages = require("./reason/systemMessages/SystemMessages.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");

let WSClientConfig = {
  numberOfRetries: 5,
  showErrorAfterRetries: 2,
  keepAliveMs: 10000,
  timeoutInterval: 2000
};

let timeout = {
  contents: undefined
};

let queueTimout = {
  contents: () => {}
};

let clearTimeoutRef = {
  contents: () => {}
};

function useSubscriptionErrorDisplay() {
  let subscriptionErrorSystemMessage = React.useRef(undefined);
  let match = SystemMessages.useSystemMessages();
  let messages = match.messages;
  let removeMessage = match.removeMessage;
  let addMessage = match.addMessage;
  React.useEffect(() => (() => {
    let x = subscriptionErrorSystemMessage.current;
    if (x !== undefined) {
      return removeMessage(x);
    }
  }), []);
  let messageId = "subscription-error";
  let show = () => {
    if (!Stdlib_List.some(messages, param => param.id === messageId)) {
      return addMessage(SystemMessages.Message.make(messageId, "error", "There was a connection error. Please try refreshing...", 0, param => JsxRuntime.jsx(ButtonsV5.OutlineButton.make, {
        onClick: param => {
          window.location.reload();
        },
        children: "Refresh"
      }), false));
    }
  };
  let hide = () => removeMessage(messageId);
  return [
    show,
    hide
  ];
}

let dispatch = {
  contents: param => {}
};

let initialValue = {
  status: "Closed",
  failedConnectionAttempts: 0
};

function useDisplaySubscriptionConnectionErrors() {
  let match = ReactUpdate.useReducer((state, action) => {
    switch (state.status) {
      case "Closed" :
        switch (action) {
          case "Closed" :
            return "NoUpdate";
          case "Connecting" :
            return {
              TAG: "Update",
              _0: {
                status: "Connecting",
                failedConnectionAttempts: state.failedConnectionAttempts
              }
            };
          case "Connected" :
            return {
              TAG: "Update",
              _0: {
                status: "Connected",
                failedConnectionAttempts: 0
              }
            };
        }
      case "Connecting" :
        switch (action) {
          case "Closed" :
            return {
              TAG: "Update",
              _0: {
                status: "Closed",
                failedConnectionAttempts: state.failedConnectionAttempts + 1 | 0
              }
            };
          case "Connecting" :
            return "NoUpdate";
          case "Connected" :
            return {
              TAG: "Update",
              _0: {
                status: "Connected",
                failedConnectionAttempts: 0
              }
            };
        }
      case "Connected" :
        switch (action) {
          case "Closed" :
            return {
              TAG: "Update",
              _0: {
                status: "Closed",
                failedConnectionAttempts: state.failedConnectionAttempts
              }
            };
          case "Connecting" :
          case "Connected" :
            return "NoUpdate";
        }
    }
  }, initialValue);
  let send = match[1];
  let state = match[0];
  React.useEffect(() => {
    dispatch.contents = send;
    return () => {
      dispatch.contents = param => {};
    };
  }, []);
  let match$1 = useSubscriptionErrorDisplay();
  let hide = match$1[1];
  let show = match$1[0];
  React.useEffect(() => {
    if (state.failedConnectionAttempts > 2) {
      show();
    } else {
      hide();
    }
  }, [state.failedConnectionAttempts]);
}

function GraphQLWSClient$SocketStatus(props) {
  useDisplaySubscriptionConnectionErrors();
  return null;
}

let SocketStatus = {
  initialValue: initialValue,
  useDisplaySubscriptionConnectionErrors: useDisplaySubscriptionConnectionErrors,
  make: GraphQLWSClient$SocketStatus
};

let wsStateUpdateListeners = [];

function notifyWsStateUpdateListeners(status) {
  wsStateUpdateListeners.forEach(listener => listener(status));
}

function addWsStateUpdateListener(listener) {
  wsStateUpdateListeners.push(listener);
  return () => {
    wsStateUpdateListeners.splice(wsStateUpdateListeners.indexOf(listener), 1);
  };
}

function useOnWsStatusUpdated(cb) {
  React.useEffect(() => addWsStateUpdateListener(cb), [cb]);
}

let match = globalThis.window;

let client = match !== undefined ? Primitive_option.some(GraphqlWs.createClient({
    url: Env.graphqlWsHost + `/ws/graphql`,
    shouldRetry: param => true,
    keepAlive: 10000,
    connectionParams: async () => {
      let token = await AuthSession.getWithExpiryCheck("ws-connection-params");
      return Object.fromEntries(Stdlib_Option.getOr(Stdlib_Option.map(token, t => [[
          "token",
          t
        ]]), []));
    },
    on: {
      closed: param => {
        dispatch.contents("Closed");
        notifyWsStateUpdateListeners("Closed");
      },
      connected: (param, param$1) => {
        dispatch.contents("Connected");
        notifyWsStateUpdateListeners("Connected");
      },
      connecting: () => {
        dispatch.contents("Connecting");
        notifyWsStateUpdateListeners("Connecting");
      },
      ping: (received, param) => {
        if (!received) {
          return queueTimout.contents();
        }
      },
      pong: (received, param) => {
        if (received) {
          return clearTimeoutRef.contents();
        }
      }
    },
    retryAttempts: 5
  })) : undefined;

queueTimout.contents = () => {
  if (client === undefined) {
    return;
  }
  let client$1 = Primitive_option.valFromOption(client);
  let timeoutId = setTimeout(() => {
    client$1.terminate();
  }, 2000);
  timeout.contents = Primitive_option.some(timeoutId);
};

clearTimeoutRef.contents = () => {
  let timeoutId = timeout.contents;
  if (timeoutId !== undefined) {
    clearTimeout(Primitive_option.valFromOption(timeoutId));
    return;
  }
};

let make = GraphQLWSClient$SocketStatus;

exports.WSClientConfig = WSClientConfig;
exports.timeout = timeout;
exports.queueTimout = queueTimout;
exports.clearTimeoutRef = clearTimeoutRef;
exports.useSubscriptionErrorDisplay = useSubscriptionErrorDisplay;
exports.dispatch = dispatch;
exports.SocketStatus = SocketStatus;
exports.make = make;
exports.wsStateUpdateListeners = wsStateUpdateListeners;
exports.notifyWsStateUpdateListeners = notifyWsStateUpdateListeners;
exports.addWsStateUpdateListener = addWsStateUpdateListener;
exports.useOnWsStatusUpdated = useOnWsStatusUpdated;
exports.client = client;
/* match Not a pure module */
